// extracted by mini-css-extract-plugin
module.exports = {"titleAndFilter":"styles-module__titleAndFilter___1XE1Q","header":"styles-module__header___2Li3q","communityTrigger":"styles-module__communityTrigger___gtb1N"};